export const listingRequiredFields = [
  'cityState',
  'country',
];

export const userRequiredFields = [
  'firstName',
  'lastName',
  'phoneNumber'
];

